/**
 * Sales-demo UI (one-click login + banner).
 *
 * Turns on when:
 *   - REACT_APP_DEMO_MODE=true (local / demo brand build), or
 *   - the customer opens /demo or /login?demo=1 (shareable public link)
 *
 * The URL flag is stored in sessionStorage so the banner stays after login.
 * Regular /login without the flag stays clean for real employees.
 */
export const DEMO_STORAGE_KEY = "hrms_demo_mode";

export const IS_DEMO_MODE = process.env.REACT_APP_DEMO_MODE === "true";

/** Shared password for every seeded sales-demo account (seed-test-accounts). */
export const DEMO_PASSWORD = "Test@1234";

export const DEMO_ACCOUNTS = [
  {
    key: "employee",
    label: "موظف",
    hint: "يقدم إجازة ويشوف حضوره",
    identifier: "emp.ops@test.com",
  },
  {
    key: "manager",
    label: "مدير مباشر",
    hint: "يوافق على الطلبات",
    identifier: "teamleader@test.com",
  },
  {
    key: "hr",
    label: "موارد بشرية",
    hint: "يرى الشركة كلها",
    identifier: "hr@test.com",
  },
];

function readUrlDemoFlag() {
  if (typeof window === "undefined") return false;
  try {
    const { pathname, search } = window.location;
    if (pathname === "/demo" || pathname.startsWith("/demo/")) return true;
    const params = new URLSearchParams(search);
    return params.get("demo") === "1";
  } catch {
    return false;
  }
}

function readStoredDemoFlag() {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(DEMO_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/** Persist URL-based demo so banner/shortcuts survive navigation after login. */
export function activateDemoMode() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(DEMO_STORAGE_KEY, "1");
  } catch {
    // ignore quota / private mode
  }
}

export function isDemoMode() {
  if (IS_DEMO_MODE) return true;
  if (readUrlDemoFlag()) {
    activateDemoMode();
    return true;
  }
  return readStoredDemoFlag();
}

const demoMode = {
  DEMO_STORAGE_KEY,
  IS_DEMO_MODE,
  DEMO_PASSWORD,
  DEMO_ACCOUNTS,
  activateDemoMode,
  isDemoMode,
};

export default demoMode;
